"use client";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import type { StorageAdapter, StorageContextValue } from "./adapter";
import { getLocalAdapter } from "./local-idb";
import { HostEmbeddedStorage, probeHostRPC } from "./host-rpc";

const StorageContext = createContext<StorageContextValue | null>(null);

export function StorageProvider({ children }: { children: React.ReactNode }) {
  const [adapter, setAdapter] = useState<StorageAdapter | null>(null);
  useEffect(() => {
    let active = true;
    (async () => {
      const embedded = window.top !== window;
      if (embedded && (await probeHostRPC())) {
        if (!active) return;
        setAdapter(new HostEmbeddedStorage(window.parent!));
      } else {
        if (!active) return;
        setAdapter(getLocalAdapter());
      }
    })();
    return () => {
      active = false;
    };
  }, []);
  const value = useMemo(() => (adapter ? { adapter } : null), [adapter]);
  if (!value) return null;
  return <StorageContext.Provider value={value}>{children}</StorageContext.Provider>;
}

export function useStorage() {
  const ctx = useContext(StorageContext);
  if (!ctx) throw new Error("StorageContext missing");
  return ctx;
}
